import { Typography } from '@mui/material';
import React, { memo, useCallback } from 'react';

import { InvestorsTable } from '~/components/InvestorsTable';
import { GetCompanyResponse } from '~/services/rtkQuery/company/types';

interface Props {
  data: GetCompanyResponse['result']['data']['rounds'][number]['sub_rounds'][number]['investors'];
}

const Component: React.FC<Props> = ({ data }) => {
  const getTotalFieldCount = useCallback(
    (
      investors: GetCompanyResponse['result']['data']['rounds'][number]['sub_rounds'][number]['investors'],
      field: keyof GetCompanyResponse['result']['data']['rounds'][number]['sub_rounds'][number]['investors'][number],
    ) => {
      return investors.reduce((acc, investor) => {
        return investor[field] ? acc + 1 : acc;
      }, 0);
    },
    [],
  );

  return (
    <div>
      <Typography color="text.primary" fontWeight="700" mb="20px" mt="28px" variant="subtitle1">
        Investors{' '}
        <Typography component="span" variant="subtitle1">
          (Total {data.length})
        </Typography>
      </Typography>
      <InvestorsTable
        data={data}
        totalCorporate={getTotalFieldCount(data, 'corporate')}
        totalFollowOn={data.length - getTotalFieldCount(data, 'new')}
        totalLeads={getTotalFieldCount(data, 'lead')}
        totalNew={getTotalFieldCount(data, 'new')}
      />
    </div>
  );
};

export const Investors = memo(Component);
